
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon feather-heart","d":"M14.766 1.238a4.2 4.2 0 00-5.955 0L8 2.052l-.811-.814a4.218 4.218 0 10-5.955 5.974l.811.814L8 14.003l5.955-5.974.811-.814a4.233 4.233 0 000-5.974z","fill":"#f36628"}})])
          )
        }
      }
    